import { BehaviorSubject } from 'rxjs';

export const headerSubject$ = new BehaviorSubject({});

export const headerOffsetHeight = headerSubject$.asObservable();